export default __webpack_public_path__ + "static/media/recommend_form.b704ad1b.jpg";